module.exports = __webpack_public_path__ + "img/1726035539629-screenshot-1726035488169.png.9fbb9a75.webp";